import React from 'react';
import { Link } from 'react-router-dom';

const Thanks = () => (
  <div className="w-full flex flex-col items-center mt-24">
    <p className="font-inter font-bold text-xl text-primary-100">Merci! Votre message est reçu.</p>
    <Link to="/" className="flex items-center mt-6 text-lg font-bold text-gray-600"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 mr-1 mt-1">
      <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
    </svg>
      Retour</Link>
  </div>
);

export default Thanks;
